<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<p-dialog header="Cancel this series" [(visible)]="showCancel" [style]="{width: '40vw'}" [baseZIndex]="10000" [modal]="true">
    <div class="srs-field">
        <div style="margin-bottom:12px;">
            This cancels <b>all {{bookings.length}} dates</b> of this series. It cannot be undone from here - a cancelled date has to be re-enabled one at a time.
        </div>
        <label for="cancelReason">Why is it being cancelled?</label>
        <textarea id="cancelReason" pInputText [(ngModel)]="cancelReason" style="width:100%;height:120px;"></textarea>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" label="Cancel the series" styleClass="p-button p-button-danger" [disabled]="saving" (click)="cancelSeries()"></p-button>
        <p-button icon="pi pi-chevron-left" label="Leave it alone" styleClass="p-button p-button-secondary" (click)="showCancel = false"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Refund Payment" [(visible)]="showRefund" [style]="{width: '50vw'}" [baseZIndex]="10000" [modal]="true">
    <div class="srs-field">
        <label for="refundAmount">Refund Value</label>
        <p-inputNumber inputId="refundAmount" [(ngModel)]="refundAmount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="refundMax"></p-inputNumber>
    </div>
    <div *ngIf="!refundAmountValid" class="srs-error"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Enter a refund value of no more than {{refundMax | currency:CurrencySymbol}}.</div>

    <div class="srs-field">
        <label for="refundReason">Refund Reason</label>
        <textarea id="refundReason" pInputText [(ngModel)]="refundReason" style="width:100%;height:100px;"></textarea>
    </div>
    <div *ngIf="!refundReasonValid" class="srs-error"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Reason.</div>

    <p><b>Items will be refunded to the same payment type as the payment was originally made in.</b></p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" label="Refund" styleClass="p-button p-button-success" [disabled]="saving" (click)="doRefund()"></p-button>
        <p-button icon="pi pi-times" label="Cancel" styleClass="p-button p-button-danger" (click)="showRefund = false"></p-button>
    </ng-template>
</p-dialog>

<div *ngIf="AccessAllowed" style="padding: 1rem;">

    <div class="srs-head">
        <h3 style="margin:0;">
            <span class="pi pi-sync" style="margin-right:10px;"></span>Edit Series
        </h3>
        <button pButton type="button" style="height:40px;" class="p-button p-button-outlined p-button-secondary" (click)="returnToList()">
            <span class="pi pi-chevron-left" style="margin-right:6px;"></span>
            <span>Return</span>
        </button>
    </div>

    <div *ngIf="loaded && bookings.length == 0" class="surface-card p-4 shadow-2 border-round">
        No bookings were found for this series.
    </div>

    <div *ngIf="bookings.length > 0">

        <p class="m-0 mb-4 p-0 text-600 line-height-3">
            <span class="pi pi-info-circle" style="margin-right:2px;"></span>
            {{lead.packageName}} for {{customerName}} &middot; {{bookings.length}} dates from {{firstDate | date:'EEE dd/MM/yyyy' : 'UTC'}} to {{lastDate | date:'EEE dd/MM/yyyy' : 'UTC'}}
        </p>

        <div class="srs-figures">
            <div class="srs-figure">
                <div class="srs-figure-label">Dates</div>
                <div class="srs-figure-value">{{bookings.length}}</div>
            </div>
            <div class="srs-figure">
                <div class="srs-figure-label">People</div>
                <div class="srs-figure-value">{{totalPeople}}</div>
            </div>
            <div class="srs-figure">
                <div class="srs-figure-label">Series Value</div>
                <div class="srs-figure-value">{{seriesTotal | currency:CurrencySymbol}}</div>
            </div>
            <div class="srs-figure">
                <div class="srs-figure-label">Paid</div>
                <div class="srs-figure-value srs-figure-value--paid">{{seriesPaid | currency:CurrencySymbol}}</div>
            </div>
            <div class="srs-figure">
                <div class="srs-figure-label">Outstanding</div>
                <div class="srs-figure-value" [ngClass]="seriesOutstanding > 0 ? 'srs-figure-value--owed' : 'srs-figure-value--paid'">{{seriesOutstanding | currency:CurrencySymbol}}</div>
            </div>
            <div *ngIf="seriesRefunded > 0" class="srs-figure">
                <div class="srs-figure-label">Refunded</div>
                <div class="srs-figure-value srs-figure-value--owed">{{seriesRefunded | currency:CurrencySymbol}}</div>
            </div>
        </div>

        <div *ngIf="allDisabled" class="srs-scope" style="background:#fee2e2;border-color:#fca5a5;">
            <span class="pi pi-ban" style="margin-right:8px;"></span>
            Every date in this series has been cancelled.
        </div>

        <!-- Named after a change is refused, so staff can see exactly which dates stood in the way. -->
        <div *ngIf="failedDates.length > 0" class="srs-scope" style="background:#fee2e2;border-color:#fca5a5;">
            <div style="font-weight:bold;margin-bottom:6px;">
                <span class="pi pi-exclamation-triangle" style="margin-right:8px;"></span>
                Nothing was changed. These dates could not take it:
            </div>
            <div *ngFor="let failed of failedDates">
                &nbsp;&middot; {{failed.startTime | date:'EEE dd/MM/yyyy HH:mm' : 'UTC'}} ({{failed.bookingIdHR}})
            </div>
        </div>

        <p-tabView [(activeIndex)]="activeIndex">

            <p-tabPanel header="Dates">
                <ng-template pTemplate="header">
                    <i class="pi pi-calendar" style="margin-right: 5px;"></i>
                    <span>Dates</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">
                        <p-table [value]="bookings" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <!-- No money per date: the series is paid as a whole, so its figures are at the top. -->
                                    <th style="width:34%">Date</th>
                                    <th style="width:14%">Time</th>
                                    <th style="width:26%">Sales ID</th>
                                    <th style="width:14%">People</th>
                                    <th style="width:12%">&nbsp;</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item>
                                <tr [ngClass]="{'srs-row--disabled': item.disabled}">
                                    <td>
                                        <b>{{item.startTime | date:'EEE dd/MM/yyyy' : 'UTC'}}</b>
                                        <span *ngIf="item.disabled" class="srs-status--owed">&nbsp;- Cancelled</span>
                                    </td>
                                    <td>{{item.startTime | date:'HH:mm' : 'UTC'}}</td>
                                    <td>{{item.bookingIdHR}}</td>
                                    <td>{{peopleOn(item)}}</td>
                                    <td>
                                        <button pButton type="button" style="height:32px;" class="p-button-sm p-button-outlined p-button-secondary" (click)="viewBooking(item.bookingId)">
                                            <span class="pi pi-eye" style="margin-right:6px;"></span>
                                            <span>View</span>
                                        </button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="srs-actions" style="margin-top:20px;">
                            <button pButton type="button" style="height:50px;" class="p-button p-button-danger" [disabled]="saving || allDisabled" (click)="showCancel = true">
                                <span class="pi pi-times" style="margin-right:8px;"></span>
                                <span>Cancel the whole series</span>
                            </button>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="People">
                <ng-template pTemplate="header">
                    <i class="pi pi-users" style="margin-right: 5px;"></i>
                    <span>People</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">

                        <div class="srs-scope">
                            <span class="pi pi-sync" style="margin-right:8px;"></span>
                            The series runs with the same people on every date. Every date is checked for room before anything is saved - if one date can't take the new numbers, nothing is changed.
                        </div>

                        <div *ngIf="admissions.length == 0">The admissions for this package could not be read.</div>

                        <div *ngIf="admissions.length > 0" class="srs-form">
                            <div class="srs-field" *ngFor="let a of admissions">
                                <label [for]="'ad' + a.admissionid">{{a.bookingwizardtext}}</label>
                                <p-inputNumber [inputId]="'ad' + a.admissionid" [(ngModel)]="a.noofpeople" [disabled]="a.fixed" [showButtons]="true" [min]="a.min" [max]="a.max" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                            </div>

                            <div style="margin-bottom:14px;">
                                <b>Total people:</b> {{totalPeople}}
                            </div>

                            <div class="srs-actions">
                                <button pButton type="button" style="height:50px;" class="p-button p-button" [disabled]="saving" (click)="savePeopleToAll()">
                                    <span class="pi pi-save" style="margin-right:8px;"></span>
                                    <span>Check and save to all {{bookings.length}} dates</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Time">
                <ng-template pTemplate="header">
                    <i class="pi pi-clock" style="margin-right: 5px;"></i>
                    <span>Time</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">

                        <div class="srs-scope">
                            <span class="pi pi-sync" style="margin-right:8px;"></span>
                            A repeating package runs only at the times set against its dates in the package - it doesn't use Start Times. Each date is offered its own times, because a package can run at a time on one date and not on another. Change as many dates as you like and save them together; if any one of them can't take its new time, none are moved. The dates themselves are set by the package and can't be changed here.
                        </div>

                        <p-table [value]="timeRows" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:34%">Date</th>
                                    <th style="width:16%">Currently</th>
                                    <th style="width:30%">Runs at</th>
                                    <th style="width:20%">&nbsp;</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr [ngClass]="{'srs-row--disabled': row.booking.disabled}">
                                    <td>
                                        <b>{{row.booking.startTime | date:'EEE dd/MM/yyyy' : 'UTC'}}</b>
                                        <span *ngIf="row.booking.disabled" class="srs-status--owed">&nbsp;- Cancelled</span>
                                    </td>
                                    <td>{{row.current}}</td>
                                    <td>
                                        <p-dropdown [options]="row.options" [(ngModel)]="row.chosen" [disabled]="row.options.length < 2" appendTo="body"></p-dropdown>
                                    </td>
                                    <td>
                                        <span *ngIf="row.chosen != row.current" style="color:#6d28d9;font-weight:bold;">Moving to {{row.chosen}}</span>
                                        <span *ngIf="row.chosen == row.current && row.options.length < 2" style="color:#6b7280;">Only time on this date</span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="srs-actions" style="margin-top:20px;">
                            <button pButton type="button" style="height:50px;" class="p-button p-button" [disabled]="saving || changedTimeCount == 0" (click)="saveTimes()">
                                <span class="pi pi-save" style="margin-right:8px;"></span>
                                <span>Save {{changedTimeCount}} changed {{changedTimeCount == 1 ? 'date' : 'dates'}}</span>
                            </button>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Extras">
                <ng-template pTemplate="header">
                    <i class="pi pi-star" style="margin-right: 5px;"></i>
                    <span>Extras</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">

                        <div class="srs-scope">
                            <span class="pi pi-sync" style="margin-right:8px;"></span>
                            Extras are the same on every date. What is set here is sold on all {{bookings.length}} dates - a quantity of 1 means one per date, not one for the series.
                        </div>

                        <div *ngIf="extras.length == 0">This package has no extras.</div>

                        <div *ngIf="extras.length > 0" class="srs-form">
                            <div class="srs-field" *ngFor="let extra of extras">
                                <label [for]="'ex' + extra.id">
                                    {{extra.name}}
                                    <span *ngIf="extra.price > 0" style="font-weight:normal;color:#6b7280;">&nbsp;- {{extra.price | currency:CurrencySymbol}} each, per date</span>
                                </label>
                                <p-inputNumber [inputId]="'ex' + extra.id" [(ngModel)]="extra.qty" [showButtons]="true" [min]="0" [max]="extra.max > 0 ? extra.max : 99" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>

                                <div *ngIf="extra.qty > 0 && extra.question != null && extra.question != ''" style="margin-top:10px;">
                                    <label [for]="'exq' + extra.id">{{extra.question}}</label>
                                    <input [id]="'exq' + extra.id" type="text" [(ngModel)]="extra.answer" pInputText>
                                </div>
                            </div>

                            <div class="srs-actions">
                                <button pButton type="button" style="height:50px;" class="p-button p-button" [disabled]="saving" (click)="saveExtrasToAll()">
                                    <span class="pi pi-save" style="margin-right:8px;"></span>
                                    <span>Save to all {{bookings.length}} dates</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Customer">
                <ng-template pTemplate="header">
                    <i class="pi pi-user" style="margin-right: 5px;"></i>
                    <span>Customer</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">

                        <div class="srs-scope">
                            <span class="pi pi-sync" style="margin-right:8px;"></span>
                            The customer is the same on every date. Saving here writes these details to all {{bookings.length}} bookings.
                        </div>

                        <div *ngIf="customer == null">There is no customer on this series.</div>

                        <div *ngIf="customer != null" class="srs-form">
                            <div class="srs-field">
                                <label for="firstName">First Name</label>
                                <input id="firstName" type="text" [(ngModel)]="customer.firstName" pInputText autocomplete="given-name">
                            </div>
                            <div *ngIf="!firstNameValid" class="srs-error"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a first name.</div>

                            <div class="srs-field">
                                <label for="lastName">Last Name</label>
                                <input id="lastName" type="text" [(ngModel)]="customer.lastName" pInputText autocomplete="family-name">
                            </div>
                            <div *ngIf="!lastNameValid" class="srs-error"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a last name.</div>

                            <div class="srs-field">
                                <label for="email">Email</label>
                                <input id="email" type="email" [(ngModel)]="customer.email" pInputText autocomplete="email">
                            </div>
                            <div *ngIf="!emailValid" class="srs-error"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid email address.</div>

                            <div class="srs-field">
                                <label for="mobile">Mobile</label>
                                <input id="mobile" type="tel" [(ngModel)]="customer.mobile" pInputText autocomplete="mobile">
                            </div>
                            <div *ngIf="!mobileValid" class="srs-error"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid mobile number.</div>

                            <div class="srs-field">
                                <label for="address1">Address 1</label>
                                <input id="address1" type="text" [(ngModel)]="customer.address1" pInputText autocomplete="address-line1">
                            </div>

                            <div class="srs-field">
                                <label for="address2">Address 2</label>
                                <input id="address2" type="text" [(ngModel)]="customer.address2" pInputText autocomplete="address-line2">
                            </div>

                            <div class="srs-field">
                                <label for="town">Town / City</label>
                                <input id="town" type="text" [(ngModel)]="customer.townCity" pInputText autocomplete="address-level2">
                            </div>

                            <div class="srs-field">
                                <label for="postcode">Post Code</label>
                                <input id="postcode" type="text" [(ngModel)]="customer.postCode" pInputText autocomplete="postal-code">
                            </div>

                            <div class="srs-actions">
                                <button pButton type="button" style="height:50px;" class="p-button p-button" [disabled]="saving" (click)="saveCustomerToAll()">
                                    <span class="pi pi-save" style="margin-right:8px;"></span>
                                    <span>Save to all {{bookings.length}} dates</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Notes">
                <ng-template pTemplate="header">
                    <i class="pi pi-file" style="margin-right: 5px;"></i>
                    <span>Notes</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">

                        <div class="srs-scope">
                            <span class="pi pi-sync" style="margin-right:8px;"></span>
                            Saving replaces the notes on every date of the series.
                        </div>

                        <div class="srs-form">
                            <div class="srs-field">
                                <label for="notes">Notes</label>
                                <textarea id="notes" pInputText [(ngModel)]="notes" style="height:180px;"></textarea>
                            </div>

                            <div class="srs-actions">
                                <button pButton type="button" style="height:50px;" class="p-button p-button" [disabled]="saving" (click)="saveNotesToAll()">
                                    <span class="pi pi-save" style="margin-right:8px;"></span>
                                    <span>Save to all {{bookings.length}} dates</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Payments">
                <ng-template pTemplate="header">
                    <i class="pi pi-pound" style="margin-right: 5px;"></i>
                    <span>Payments</span>
                </ng-template>
                <ng-template pTemplate="body">

                    <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                        <label class="font-medium">Payments already made across the series</label>

                        <div *ngIf="allPayments.length == 0" style="margin-top:10px;">
                            No payments have been made against this series.
                        </div>

                        <p-table *ngIf="allPayments.length > 0" [value]="allPayments" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:1%"></th>
                                    <th style="width:18%">Date paid</th>
                                    <th style="width:16%">Booking date</th>
                                    <th style="width:16%">Sales ID</th>
                                    <th style="width:12%">Method</th>
                                    <th style="width:12%" class="srs-money">Amount</th>
                                    <th style="width:12%" class="srs-money">Balance</th>
                                    <th style="width:12%">&nbsp;</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-payment>
                                <tr>
                                    <td>
                                        <img *ngIf="payment.amount > 0" alt="Payment" src="assets/images/paymentin.png" style="width: 25px; height: 25px;"/>
                                        <img *ngIf="payment.amount <= 0" alt="Refund" src="assets/images/paymentout.png" style="width: 25px; height: 25px;"/>
                                    </td>
                                    <td [ngClass]="{'srs-status--owed': payment.amount <= 0}">{{payment.paymentDate | date:'dd/MM/yyyy HH:mm'}}</td>
                                    <td>{{payment.bookingStart | date:'EEE dd/MM/yyyy' : 'UTC'}}</td>
                                    <td>{{payment.bookingIdHR}}</td>
                                    <td>{{payment.method}}</td>
                                    <td class="srs-money">{{payment.amount | currency:CurrencySymbol}}</td>
                                    <td class="srs-money">
                                        <span *ngIf="payment.amount > 0">{{payment.balance | currency:CurrencySymbol}}</span>
                                    </td>
                                    <td>
                                        <!-- As on a booking: refundable while some of the payment is left. -->
                                        <button *ngIf="payment.amount > 0" pButton type="button" style="height:36px;width:100px;" class="p-button p-button-danger" [disabled]="payment.balance <= 0 || !payment.paymentId || saving" (click)="setupRefund(payment)">
                                            <span>Refund</span>
                                        </button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <div *ngIf="seriesDiscounts.length > 0" class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                        <label class="font-medium">Discounts applied</label>

                        <p-table [value]="seriesDiscounts" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:30%">Date</th>
                                    <th style="width:25%">User</th>
                                    <th style="width:30%">Discount Name</th>
                                    <th style="width:15%" class="srs-money">Amount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-discount>
                                <tr>
                                    <td>{{discount.discountdate | date:'dd/MM/yyyy HH:mm'}}</td>
                                    <td>{{discount.username}}</td>
                                    <td>{{discount.name}}</td>
                                    <td class="srs-money">{{discount.totaldiscount | currency:CurrencySymbol}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <div class="surface-card p-4 shadow-2 border-round">
                        <label class="font-medium">Take a payment</label>

                        <div class="srs-form">
                            <div class="srs-field">
                                <label for="paymentAmount">Payment Value</label>
                                <p-inputNumber inputId="paymentAmount" [(ngModel)]="paymentAmount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="99999"></p-inputNumber>
                            </div>
                            <div *ngIf="!paymentValueValid" class="srs-error"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a payment amount.</div>

                            <!-- Discounts belong to the bookings, so a series discount is put on every date. -->
                            <div *ngIf="showDiscount" class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                                <p-selectButton [style]="{'width': '100%', 'max-width' : '430px', 'margin-bottom' : '20px'}" [options]="stateOptionOpenDiscount" [(ngModel)]="openDiscount"></p-selectButton>

                                <div *ngIf="openDiscount" class="srs-field">
                                    <label for="discountAmount">Enter Discount Amount</label>
                                    <p-inputNumber inputId="discountAmount" [(ngModel)]="chosenDiscountAmount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="seriesOutstanding"></p-inputNumber>
                                </div>

                                <div *ngIf="!openDiscount" class="srs-field">
                                    <label for="discountCode">Enter Discount Code</label>
                                    <input id="discountCode" [(ngModel)]="discountCode" pInputText>
                                </div>

                                <button *ngIf="openDiscount" pButton type="button" style="height: 50px; width: 221px;" class="p-button p-button" [disabled]="saving" (click)="applySeriesOpenDiscount()">
                                    <span>Apply Discount</span>
                                    <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                </button>
                                <button *ngIf="!openDiscount" pButton type="button" style="height: 50px; width: 221px;" class="p-button p-button" [disabled]="saving" (click)="applySeriesDiscountCode()">
                                    <span>Apply Discount</span>
                                    <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                </button>
                            </div>

                            <div *ngIf="showVoucher" class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                                <div class="srs-field">
                                    <label for="voucherCode">Enter Gift Voucher</label>
                                    <input id="voucherCode" [(ngModel)]="voucherCode" pInputText>
                                </div>
                                <div class="srs-field">
                                    <label for="voucherPIN">Enter PIN</label>
                                    <input id="voucherPIN" [(ngModel)]="voucherpin" pInputText [maxlength]="4" type="password">
                                </div>
                                <button pButton type="button" style="height: 50px; width: 221px;" class="p-button p-button" [disabled]="saving" (click)="applyVoucher()">
                                    <span>Apply</span>
                                </button>
                            </div>

                        </div>

                        <div class="srs-actions">
                                <button *ngFor="let p of PaymentTypes" [disabled]="saving" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button" (click)="takeSeriesPayment(p.id, p.name)">
                                    <span *ngIf="p.name=='Cash' && CurrencySymbol=='GBP'" class="pi pi-pound" style="margin-right:8px;"></span>
                                    <span *ngIf="p.name=='Cash' && CurrencySymbol=='USD'" class="pi pi-dollar" style="margin-right:8px;"></span>
                                    <span *ngIf="p.name=='Cash' && CurrencySymbol=='EUR'" class="pi pi-euro" style="margin-right:8px;"></span>
                                    <span *ngIf="p.name=='Cash' && CurrencySymbol=='AUD'" class="pi pi-dollar" style="margin-right:8px;"></span>
                                    <span *ngIf="p.name=='Card'" class="pi pi-credit-card" style="margin-right:8px;"></span>
                                    <span *ngIf="p.name!='Cash' && p.name!='Card'" class="pi pi-money-bill" style="margin-right:8px;"></span>
                                    <span>Pay With {{p.name}}</span>
                                </button>

                                <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="showDiscount = !showDiscount">
                                    <span class="pi" [ngClass]="showDiscount ? 'pi-arrow-circle-left' : 'pi-arrow-circle-down'" style="margin-right:8px;"></span>
                                    <span>{{showDiscount ? 'Hide Discount' : 'Enter Discount'}}</span>
                                </button>

                                <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="showVoucher = !showVoucher">
                                    <span class="pi pi-ticket" style="margin-right:8px;"></span>
                                    <span>{{showVoucher ? 'Hide Gift Voucher' : 'Enter Gift Voucher'}}</span>
                                </button>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="History">
                <ng-template pTemplate="header">
                    <i class="pi pi-history" style="margin-right: 5px;"></i>
                    <span>History</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">
                        <label class="font-medium">What has happened to this series</label>

                        <div *ngIf="seriesHistory.length == 0" style="margin-top:10px;">
                            No history has been recorded for this series.
                        </div>

                        <p-table *ngIf="seriesHistory.length > 0" [value]="seriesHistory" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:20%">When</th>
                                    <th style="width:60%">What happened</th>
                                    <th style="width:20%">By</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                                <tr>
                                    <td>{{item.when | date:'dd/MM/yyyy HH:mm'}}</td>
                                    <td style="word-break:break-word;"><span *ngIf="(item.text ?? '').length <= historyLimit || expandedHistory.has(rowIndex)">{{item.text}}</span><span *ngIf="(item.text ?? '').length > historyLimit && !expandedHistory.has(rowIndex)">{{item.text.substring(0, historyLimit).trimEnd()}}&hellip;<button type="button" class="history-more" title="Show the whole entry" (click)="toggleHistory(rowIndex)">more</button></span><button type="button" *ngIf="(item.text ?? '').length > historyLimit && expandedHistory.has(rowIndex)" class="history-more" title="Show less" (click)="toggleHistory(rowIndex)">less</button></td>
                                    <td>{{item.user}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </ng-template>
            </p-tabPanel>

        </p-tabView>
    </div>
</div>
